"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardShortcutPanelWithL10n = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var l10n_1 = require("@paprika/l10n");
var l10n_2 = __importDefault(require("@paprika/l10n"));
var constants_1 = require("../../constants");
var NavigationButton_1 = __importDefault(require("../NavigationButton/NavigationButton"));
var NavigationIcon_1 = __importDefault(require("../NavigationIcon/NavigationIcon"));
var shortcutHelpers_1 = require("./shortcutHelpers");
var ShortcutPanel_1 = __importDefault(require("./ShortcutPanel/ShortcutPanel"));
var useShortcutPanel_1 = __importDefault(require("./hooks/useShortcutPanel"));
var sc = __importStar(require("./KeyboardShortcutPanel.styles"));
var locales_1 = __importDefault(require("../../../locales"));
function KeyboardShortcutPanelWithL10n(_a) {
    var appId = _a.appId, isOpen = _a.isOpen, handleToggleSidePanel = _a.handleToggleSidePanel;
    return (react_1.default.createElement(l10n_2.default, { locales: locales_1.default },
        react_1.default.createElement(ShortcutPanel_1.default, { appId: appId, isOpen: isOpen, handleToggleSidePanel: handleToggleSidePanel })));
}
exports.KeyboardShortcutPanelWithL10n = KeyboardShortcutPanelWithL10n;
KeyboardShortcutPanelWithL10n.propTypes = {
    appId: prop_types_1.default.string,
    isOpen: prop_types_1.default.bool.isRequired,
    handleToggleSidePanel: prop_types_1.default.func.isRequired,
};
KeyboardShortcutPanelWithL10n.defaultProps = {
    appId: shortcutHelpers_1.SECTIONS.DEFAULT,
};
function KeyboardShortcutPanel(_a) {
    var appId = _a.appId, zIndex = _a.zIndex;
    var i18n = l10n_1.useI18n();
    var _b = useShortcutPanel_1.default(), isOpen = _b[0], handleToggleSidePanel = _b[1];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(sc.NavigationHelperKeyboard, null,
            react_1.default.createElement(NavigationButton_1.default, { ariaLabel: i18n.t('global_navigation.navigation_items.keyboard_shortcut_panel_tooltip'), onClick: handleToggleSidePanel },
                react_1.default.createElement(NavigationIcon_1.default, { icon: constants_1.icons.keyboardShortcutPanel }))),
        react_1.default.createElement(ShortcutPanel_1.default, { appId: appId, isOpen: isOpen, handleToggleSidePanel: handleToggleSidePanel, zIndex: zIndex })));
}
KeyboardShortcutPanel.propTypes = {
    appId: prop_types_1.default.string,
    zIndex: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
};
KeyboardShortcutPanel.defaultProps = {
    appId: shortcutHelpers_1.SECTIONS.DEFAULT,
    zIndex: null,
};
KeyboardShortcutPanel.componentType = constants_1.navigationItems.keyboardShortcutPanel;
exports.default = KeyboardShortcutPanel;
//# sourceMappingURL=KeyboardShortcutPanel.js.map